import { Link } from "react-router-dom";
import LazyImage from "./lazyImage";
import AddToCart from "./addToCart/addToCart";
import "./productView.css";
import { formatAmount } from "../../shared/utils/formatters";
const { AddToCartSmall } = AddToCart;

const ProductView = ({ product }) => {
  return (
    <div className="product-card pv-card border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
      {/* <AddToCartSmall product={product} /> */}
      <Link
        to={`/product-details/${product?.slug}`}
        className="product-card__thumb flex-center overflow-hidden"
      >
        <LazyImage
          src={product?.image}
          alt={product?.name}
          style={{ objectFit: "contain" }}
        />
        {/* <span className="pv-quickview">
          <i className="ph ph-eye" />
        </span> */}
      </Link>
      <div className="product-card__content">
        <h6 className="title pv-title fw-semibold">
          <Link
            to={`/product-details/${product?.slug}`}
            className="link text-line-2"
          >
            {product.name}
          </Link>
        </h6>
        <div className="pv-price">
          <span className="pv-sale">
            {formatAmount(product.price)}
            <span className="pv-qty">/{product.quantityType}</span>
          </span>
          {product.originalPrice !== product.price && (
            <span className="pv-original">
              {formatAmount(product.originalPrice)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductView;
